module.exports = __webpack_public_path__ + "img/5.89705aa.webp";